import React, { useEffect, useRef, memo } from "react";
import { useCallSocket } from "../hooks/useCallSocket";

// 1. Use 'memo' to prevent parent re-renders from killing the call
const BroadcasterService = memo(({ user }) => {
  // 2. Use a Ref for the user to prevent hook dependency changes
  const userRef = useRef(user);
  
  // Debug Log: If you see this more than once, the component is restarting!
  useEffect(() => {
      console.log("✅✅ BROADCASTER SERVICE IS MOUNTED AND ACTIVE ✅✅");
  }, []);

  const {
    activeUsers,
    // We destructure these but don't display them to keep the DOM light
    callState 
  } = useCallSocket({
    user: userRef.current, // Use Ref to ensure stable identity
    isBroadcaster: true,
    onIncomingCall: (from) => console.log("📞 Incoming Call from Monitor:", from),
  });

  // Render a hidden 'active' indicator
  return null;
}, (prevProps, nextProps) => {
    // 3. Custom Compare: ONLY re-render if the User ID specifically changes.
    // Ignore all other prop changes.
    return prevProps.user?._id === nextProps.user?._id;
});

export { BroadcasterService };;